<div class="more-less-information-header" (click)="collapsed = !collapsed" [title]="collapsed ? 'Show More' : 'Show Less'">
    <i [class]="collapsed ? 'icon-content-chevron-right' : 'icon-content-chevron-down'"></i>
  {{ headerText }}
</div>
<div class="more-less-information-content" [class.collapsed]="collapsed">
    <ng-content></ng-content>
</div>
